import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { AuthProvider } from "react-oidc-context";

const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_gHFvG9DQi",
  client_id: "v2joncsj293oc2iu5ml30u5u5",
  redirect_uri: import.meta.env.DEV ? "http://localhost:3000" : "https://hack.georgii.tech",
  response_type: "code",
  scope: "aws.cognito.signin.user.admin email openid profile",
  loadUserInfo: true,
  client_secret: import.meta.env.VITE_COGNITO_CLIENT_SECRET,
  onSignoutCallback: ()=> {
    window.history.replaceState({}, '', "/")
  },
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
  metadataSeed: {
    authorization_endpoint: "https://hack-georgii.auth.us-east-1.amazoncognito.com/oauth2/authorize",
    token_endpoint: "https://hack-georgii.auth.us-east-1.amazoncognito.com/oauth2/token",
    end_session_endpoint: "https://hack-georgii.auth.us-east-1.amazoncognito.com/logout",
  }
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>,
)